<ng-container *ngIf="user">
    <app-nav-bar>
        <router-outlet></router-outlet>
    </app-nav-bar>
</ng-container>
<ng-container *ngIf="!user && isCheckingAuth"> Loading... </ng-container>
<p-toast position="top-right" [preventOpenDuplicates]="true"></p-toast>
